import { useTranslation } from 'react-i18next'
import Heading from '../Heading'
import Text from '../Text'
import { TYPES_MENU_LIST } from '../../constants/menu'

const TermsAndCondition = () => {
  const { t } = useTranslation()

  return (
    <div id={TYPES_MENU_LIST.TERMS_AND_CONDITIONS}>
      <Heading level={2}>{t('Términos y condiciones de compra')}</Heading>
      <Text>
        {t(
          'Los usuarios y/o clientes que visiten, naveguen y/o adquieran productos a través de portal web serán considerados usuarios y/o clientes (indistintamente) en los presentes términos y condiciones de compra.'
        )}
      </Text>
      <Heading level={3}>{t('1. Objeto y ámbito de aplicación')}</Heading>
      <Text>
        {t(
          'Las presentes condiciones de compra, tienen como objetivo regular la prestación de los servicios comerciales que se realizan el portal web https://vicensvives.com (en adelante “el PORTAL”), registrado a favor de EDITORIAL VICENS VIVES, S.A. (en adelante “VICENS VIVES”).'
        )}
      </Text>
      <Heading level={3}>
        {t('2. Obligaciones previas a la contratación')}
      </Heading>
      <Text>
        {t(
          'Para poder realizar compras en el portal web es necesario estar registrado en el PORTAL y ser mayor de edad. Si un usuario no está registrado en el PORTAL, el portal web facilitará al usuario las herramientas necesarias para que pueda registrarse como nuevo usuario durante el proceso de compra de productos.'
        )}
      </Text>
      <Text>
        {t(
          'El cliente puede elegir cualquiera de nuestros productos que desee adquirir. Una vez seleccionados todos los artículos que desee comprar deberá realizar el pedido, que será enviado a la dirección introducida en el formulario de registro de usuario.'
        )}
      </Text>
      <Text>
        {t(
          'A partir de este momento, se podrá enviar a la cesta de la compra cualquiera de los artículos que se encuentran en nuestra base de datos. Posteriormente el cliente accederá a un formulario con toda la información sobre las opciones de pago.'
        )}
      </Text>
      <Text>
        {t(
          'Las licencias digitales se envían a la dirección de correo electrónico a través de la cual se ha creado la cuenta de usuario en el PORTAL y VICENS VIVES no se hace responsable si la dirección de email facilitada no es correcta.'
        )}
      </Text>
      <Text>
        {t(
          'Cualquier error en la introducción de tus datos podrá ser subsanado a través del área personal del perfil de usuario. Si la incidencia no se puede resolver, el usuario puede ponerse en contacto con VICENS VIVES a través del'
        )}{' '}
        <a
          href='https://vicensvivesdigital.zendesk.com/hc/es/requests/new?ticket_form_id=9300037269789'
          rel='noopener noreferrer'
          target='_blank'
        >
          {t('siguiente formulario')}
        </a>
        .
      </Text>
      <Heading level={3}>{t('3. Precios e Impuestos')}</Heading>
      <Text>
        {t(
          'Los precios indicados en nuestra web tienen incluido el IVA (Impuesto sobre el Valor Añadido).'
        )}
      </Text>
      <Text>
        {t('Los libros y libros de texto tendrán un IVA aplicado del 4%.')}
      </Text>
      <Text>
        {t(
          'Los libros electrónicos y contenidos digitales educativos tendrán un IVA aplicado del 4%'
        )}
      </Text>
      <Text>
        {t(
          'El material escolar y el resto de productos tendrán un IVA aplicado del 21%'
        )}
      </Text>
      <Heading level={3}>{t('4. Alcance y gastos de envío')}</Heading>
      <Text>
        {t(
          'Por el momento, las compras realizadas a través del portal web el PORTAL, de productos en formato físico, únicamente se pueden hacer llegar al territorio español de la Península Ibérica, Islas Baleares y las Islas Canarias (no se realizan entregas de pedidos en Ceuta y Melilla) y a los siguientes países de Europa: Alemania, Bélgica, Croacia, Dinamarca, Francia, Irlanda, Letonia, Luxemburgo, Países Bajos, Suecia, Bulgaria, Eslovaquia, Estonia, Grecia, Malta, Polonia, República Checa, Austria, Chipre, Eslovenia, Finlandia, Hungría, Italia, Lituania, Portugal y Rumanía.'
        )}
      </Text>
      <Text>
        {t(
          'Los productos en formato digital se pueden adquirir en todo el mundo.'
        )}
      </Text>
      <Text>
        {t(
          'El cliente podrá consultar el importe de los gastos de envío durante el proceso de compra, antes de formalizar el pedido.'
        )}
      </Text>
      <Text>
        {t(
          'El importe de los gastos de envío se detallará durante el proceso de compra, antes de formalizar el pedido.'
        )}
      </Text>
      <Heading level={3}>
        {t('5. Disponibilidad y Plazo de Entrega de los productos')}
      </Heading>
      <Text>
        {t(
          'Los productos ofrecidos en el portal web muestran su disponibilidad online así como un rango temporal en el plazo de entrega'
        )}
        .{' '}
      </Text>
      <Text>
        {t(
          'Cuando un producto no está en stock en el PORTAL, en la misma ficha del producto aparece un campo de formulario donde el usuario podrá dejar su email de contacto y recibirá un mensaje de correo electrónico en el momento que el producto pueda volver a estar disponible en el PORTAL.'
        )}
      </Text>
      <Text>
        {t(
          'Las compras que se efectúen durante los períodos en que el servicio de expedición esté suspendido, serán tramitadas a partir de la fecha en que éste se restablezca. Dichos periodos estarán debidamente anunciados en la página web de el PORTAL.'
        )}
      </Text>
      <Text>
        {t(
          'El plazo de entrega hace referencia a días laborables de lunes a viernes. En el caso de que existiera alguna rotura de stock o indisponibilidad puntual de un artículo, VICENS VIVES se pondrá en contacto con el cliente para informarle y darle un nuevo plazo de entrega o bien ofrecerle otro producto equivalente. También podrá solicitar la cancelación del pedido sin coste alguno para el cliente.'
        )}
      </Text>
      <Text>
        {t(
          'El cliente se compromete a posibilitar la entrega del pedido solicitado facilitando una dirección de entrega en la que pueda ser entregado el pedido dentro del horario habitual de entrega de mercancías en días laborables, siendo este de lunes a viernes de 10 horas a 13:30 horas y de 16 horas a 19 horas. En caso de incumplimiento por parte del cliente de esta obligación, VICENS VIVES no tendrá ninguna responsabilidad sobre el retraso o imposibilidad de entrega del pedido solicitado por el cliente.'
        )}
      </Text>
      <Heading level={3}>{t('6. Formas de pago')}</Heading>
      <Text>{t('El pago se puede efectuar mediante dos modalidades:')}</Text>
      <Text>
        <ul>
          <li>
            {t(
              'Pago por Tarjeta de Crédito: Se pueden realizar los pagos utilizando cualquiera de las tarjetas comerciales reconocidas por las marcas VISA y Mastercard. Para los pagos con tarjeta, utilizamos una pasarela virtual desarrollada por Caixa Bank (Comercia Global Payments - Cyberpac) que permite realizar de forma segura pagos en Internet. Con este protocolo de seguridad, el número de tarjeta se introduce directamente en la web de la entidad bancaria, quedando así los datos de su tarjeta y su contraseña totalmente protegidos.'
            )}
          </li>
          <li>{t('BIZUM')}</li>
        </ul>
      </Text>
      <Heading level={3}>{t('7. Pedidos y Facturación')}</Heading>
      <Text>
        {t(
          'Los usuarios disponen de un área privada en la que pueden ver toda la relación de los pedidos realizados.'
        )}
      </Text>
      <Text>
        {t(
          'Al realizar su pedido, el cliente recibirá por correo electrónico un justificante de compra con nº de recibo y detalle de títulos e importe desglosado, el cual es el único comprobante válido para posteriores reclamaciones y estará siempre disponible en su historial online así como también estarán disponibles las facturas correspondientes.'
        )}
      </Text>
      <Heading level={3}>{t('8. Garantía de los productos')}</Heading>
      <Text>
        {t(
          'Todos los artículos vendidos por VICENS VIVES cuentan con una garantía de dos años. En caso de artículos defectuosos, VICENS VIVES procederá según corresponda, a la reparación o sustitución, gestiones que serán gratuitas para el cliente.'
        )}
      </Text>
      <Heading level={3}>{t('9. Licencias digitales')}</Heading>
      <Text>
        {t(
          'Las licencias de los libros en versión digital tendrán una validez de 13 meses a contar desde su activación.'
        )}
      </Text>
      <Heading level={3}>{t('10. Cancelaciones y devoluciones')}</Heading>
      <Text>
        {t(
          'Los pedidos se pueden cancelar sin coste alguno hasta el momento en que el envío se hace efectivo. Si recibimos aviso de cancelación una vez el paquete esté enviado, lo consideraremos una devolución.'
        )}
      </Text>
      <Text>
        {t(
          'Si el cliente decide ejercer su derecho de desistimiento, deberá comunicarse a través del'
        )}{' '}
        <a
          href='https://vicensvivesdigital.zendesk.com/hc/es/requests/new?ticket_form_id=9300037269789'
          rel='noopener noreferrer'
          target='_blank'
        >
          {t('siguiente formulario')}
        </a>
        .{' '}
        {t(
          'Las devoluciones pueden hacerse hasta 14 días naturales desde la recepción del producto, siempre y cuando estos no hayan sido abiertos ni usados y conserven –en su caso- el precinto o embalaje original y estén en perfecto estado de conservación y en condiciones de volver a ponerse a la venta. Esto no será aplicable a la venta de artículos que puedan ser reproducidos o copiados con carácter inmediato o que por razón de su naturaleza, no puedan ser objeto de devolución, entre los que se encuentran los libros digitales cuyas licencias ya han sido activadas y los libros de impresión bajo demanda (libros impresos específicamente a petición del cliente)'
        )}
        .
      </Text>
      <Text>
        {t(
          'En caso de producirse la devolución, los gastos de envío corren a cargo del cliente. Naturalmente, quedan excluidas de este supuesto aquellas devoluciones que se deriven de un error de VICENS VIVES o de algún defecto del producto servido. En ese caso, VICENS VIVES se compromete a cambiar el producto defectuoso por otro y se hará cargo de los gastos de devolución y de envío. Si no pudiera hacerse el cambio, se reintegrará el importe.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES se compromete a retornar el importe de la compra lo más rápidamente posible, una vez confirmada la incidencia y una vez el producto esté de nuevo en el centro logístico de VICENS VIVES.'
        )}
      </Text>
      <Text>
        {t(
          'Tanto para las cancelaciones como para las devoluciones de productos, el usuario debe ponerse en contacto con VICENS VIVES a través del'
        )}{' '}
        <a
          href='https://vicensvivesdigital.zendesk.com/hc/es/requests/new?ticket_form_id=9300037269789'
          rel='noopener noreferrer'
          target='_blank'
        >
          {t('siguiente formulario')}
        </a>
        .
      </Text>
      <Heading level={3}>{t('11. Atención al cliente')}</Heading>
      <Text>
        {t(
          'Los clientes pueden ponerse en contacto con VICENS VIVES para aclarar dudas o resolver incidencias que hayan podido surgir en relación al proceso de compra, estado del envío, facturación y recepción de los productos.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES proporciona el siguiente canal de contacto a través del'
        )}{' '}
        <a
          href='https://vicensvivesdigital.zendesk.com/hc/es/requests/new?ticket_form_id=9300037269789'
          rel='noopener noreferrer'
          target='_blank'
        >
          {t('siguiente formulario')}
        </a>
        .
      </Text>
      <Text>
        {t(
          'El horario de atención al cliente es de lunes a jueves (laborables) de 9:00 a 13h y de 15h a 17h y los viernes (laborables) de 9h a 14h.'
        )}
      </Text>
      <Text>
        {t(
          'Para mejorar la eficiencia de VICENS VIVES resolviendo incidencias, recomendamos a los clientes que aporten su nombre completo, DNI, email y teléfono de contacto, así como una descripción de los hechos causantes de la incidencia.'
        )}
      </Text>
      <Heading level={3}>{t('12. Propiedad intelectual e industrial')}</Heading>
      <Text>
        {t(
          'Todos los contenidos publicados en la web y especialmente los diseños, textos, gráficos, logos, iconos, botones, así como los nombres comerciales, las marcas o dibujos industriales y cualesquiera otros signos susceptibles de utilización industrial y comercial están sujetos a derechos de propiedad intelectual e industrial de VICENS VIVES o de terceros titulares de los mismos. En ningún caso se entenderá que se concede licencia alguna o se efectúa renuncia, transmisión, cesión total o parcial de dichos derechos ni se confiere ningún derecho ni expectativa de derecho, y en especial, de alteración, explotación, reproducción, distribución o comunicación pública sobre dichos contenidos sin la previa autorización expresa de VICENS VIVES o por los legítimos titulares de la propiedad industrial o intelectual.'
        )}{' '}
      </Text>
      <Heading level={3}>{t('13. Protección de Datos')}</Heading>
      <Text>
        {t(
          'VICENS VIVES respeta la legislación vigente en materia de protección de datos personales, la privacidad de los usuarios y el secreto y seguridad de los datos de conformidad con lo establecido en la legislación aplicable en materia de protección de datos, y aplica las medidas técnicas y organizativas apropiadas a fin de garantizar y poder demostrar que el tratamiento de datos de los que VICENS VIVES es responsable cumple con la referida normativa.'
        )}
      </Text>
      <Text>
        {t(
          'Los datos personales sólo serán obtenidos por VICENS VIVES para su tratamiento, cuando sean adecuados, pertinentes y no excesivos en relación con el ámbito y las finalidades determinadas, explícitas y legítimas para las que se hayan obtenido. El Usuario manifiesta que los datos facilitados son ciertos y correctos, y se compromete a comunicar a VICENS VIVES los cambios que se produzcan en los mismos.'
        )}
      </Text>
      <Text>
        {t(
          'Por ello, VICENS VIVES informa a los usuarios de los principales extremos sobre su política de privacidad y acceso a los datos personales:'
        )}
      </Text>
      <Text>
        {t('13.1. Responsable del tratamiento de datos de carácter personal')}
      </Text>
      <Text>
        {t(
          'De acuerdo con lo que establece el Reglamento Europeo 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016, el Responsable del tratamiento de datos de carácter personal es EDITORIAL VICENS VIVES, S.A. (VICENS VIVES), con domicilio en Vía Augusta, 260, Local B, 08017 de Barcelona (email de contacto: lopd@vicensvives.es).'
        )}
      </Text>
      <Text>{t('13. 2. Obtención de los datos de carácter personal')}</Text>
      <Text>
        {t(
          'Los datos de carácter personal tratados por VICENS VIVES han sido obtenidos a través de los siguientes procesos y/o canales del presente portal web:'
        )}
      </Text>
      <Text>
        <ul>
          <li>{t('Formularios de contacto')}</li>
          <li>{t('Formulario para la compra de artículos')}</li>
        </ul>
      </Text>
      <Text>
        {t('13.3. Finalidad del tratamiento de los datos de carácter personal')}
      </Text>
      <Text>
        {t(
          'VICENS VIVES trata los datos de carácter personal de los usuarios con el fin de poder prestar de manera óptima SERVICIOS VICENS VIVES. De este modo, los datos recabados de los usuarios se utilizan con distintas finalidades, en función de las peticiones de servicios de los usuarios, del interés legítimo de VICENS VIVES, y las autorizaciones y consentimientos expresos de los mismos.'
        )}
      </Text>
      <Text>
        {t(
          'Las finalidades para el tratamiento de los datos de los SERVICIOS VICENS VIVES son:'
        )}
      </Text>
      <Text>
        <ul>
          <li>{t('Atender peticiones de servicios presentes y futuras.')}</li>
          <li>
            {t(
              'Atender y gestionar sus peticiones de compra de productos de VICENS VIVES y mantener la relación comercial con los clientes de VICENS VIVES.'
            )}
          </li>
          <li>
            {t(
              'Gestionar incidencias con los usuarios de los SERVICIOS VICENS VIVES.'
            )}
          </li>
          <li>
            {t(
              'Remitir comunicaciones y notificaciones relacionadas con actualizaciones, mejoras y novedades relativas a los SERVICIOS VICENS VIVES.'
            )}
          </li>
          <li>
            {t(
              'Pedir la opinión a los usuarios de los SERVICIOS VICENS VIVES acerca de los servicios prestados por VICENS VIVES.'
            )}
          </li>
          <li>
            {t(
              'Envío de publicidad de artículos, productos y novedades de VICENS VIVES.'
            )}
          </li>
          <li>
            {t(
              'Envío de newsletters (solamente si el usuario ha realizado la petición u otorgado su consentimiento expreso para ello).'
            )}
          </li>
          <li>
            {t(
              'Cumplimiento de los deberes y obligaciones de naturaleza legal en relación al mantenimiento de datos, así como para poder dar cumplimiento a cualquier requerimiento de información cursado por una autoridad competente. Entre estas obligaciones se incluye la entrega, en determinadas circunstancias, de datos de carácter personal a los citados órganos.'
            )}
          </li>
          <li>
            {t(
              'Tratamiento de cookies. El tratamiento de datos de carácter personal recabados mediante cookies solamente se realizará tras la aceptación del sistema de cookies en la casilla/botón correspondiente'
            )}{' '}
            (
            <a href={`#${TYPES_MENU_LIST.COOKIE_POLICY}`}>
              {t('más información aquí')}
            </a>
            ).
          </li>
        </ul>
      </Text>
      <Text>
        {t(
          '13.4. Base legal para el tratamiento de los datos de carácter personal'
        )}
      </Text>
      <Text>
        {t(
          'La base legal para el tratamiento de datos de los usuarios registrados en determinados SERVICIOS VICENS VIVES cuando estén vinculados con la compra de artículos editoriales del sector educativo es el interés legítimo de VICENS VIVES.'
        )}
      </Text>
      <Text>
        {t(
          'La base legal para el tratamiento de los datos personales para el envío de publicidad y prospección comercial a los usuarios de los SERVICIOS VICENS VIVES es el consentimiento explícito e inequívoco, o el interés legítimo.'
        )}
      </Text>
      <Text>
        {t(
          'La base legal para el tratamiento de datos personales obtenidos a través de las cookies es el consentimiento explícito expresado por el usuario.'
        )}
      </Text>
      <Text>
        {t(
          'Los usuarios manifiestan haber leído y aceptado expresamente la presente Política de Privacidad, al marcar la casilla expresa a tal efecto, habilitada en cada uno de nuestros formularios de contacto, registro y/o acceso a los SERVICIOS VICENS VIVES.'
        )}
      </Text>
      <Text>{t('13.5. Comunicación de datos a terceros')}</Text>
      <Text>
        {t(
          'VICENS VIVES no cederá o comunicará a terceros los datos recabados sin previo consentimiento expreso del usuario, excepto en el caso de que la comunicación sea necesaria para prestar el servicio que el usuario haya solicitado o exista una obligación legal para realizar tal comunicación.'
        )}
      </Text>
      <Text>
        {t(
          'No obstante lo anterior, VICENS VIVES informa que, para la correcta gestión de algunas de las funciones de los SERVICIOS VICENS VIVES, existen terceras empresas que pueden tener acceso a los datos de carácter personal de los usuarios. Estas terceras empresas están obligadas legalmente a mantener la confidencialidad y secreto de la información, estando sujetas también a una estricta política de privacidad.'
        )}
      </Text>
      <Text>
        {t(
          '13.6. Mantenimiento y conservación de los datos de carácter personal'
        )}
      </Text>
      <Text>
        {t(
          'Los datos de carácter personal de los usuarios de los SERVICIOS VV serán conservados durante el tiempo necesario para cumplir la finalidad para la cual se recogieron y, cuando proceda, durante el tiempo en que pueda exigirse algún tipo de responsabilidad derivada de una relación u obligación jurídica o de la ejecución de un contrato, precontrato y/o relación mercantil con los usuarios.'
        )}
      </Text>
      <Text>
        {t(
          'Cuando un usuario se dé de baja en el sistema, sus datos serán cancelados y conservados en los sistemas de información de VICENS VIVES durante el periodo legal establecido (4 años para la información relativa a las transacciones y relaciones comerciales y 12 meses para el resto de información de los usuarios). Esta información no será accesible ni podrá ser utilizada por ningún usuario y únicamente estará a disposición de los jueces, tribunales y autoridades competentes.'
        )}
      </Text>
      <Text>
        {t(
          'Si el tratamiento de los datos de los usuarios han sido recogidos para varias finalidades distintas que obligan a su conservación durante plazos distintos, VICENS VIVES aplicará el plazo de conservación más largo.'
        )}
      </Text>

      <Text>{t('13.7. Derechos de los usuarios')}</Text>
      <Text>
        {t(
          'Los usuarios de los SERVICIOS VICENS VIVES tienen los derechos de acceso, rectificación, cancelación, oposición, limitación, olvido y portabilidad en materia de protección de datos de carácter personal. Estos derechos suponen que el usuario podrá:'
        )}
      </Text>
      <Text>
        <ul>
          <li>
            {t(
              'Revocar su consentimiento para el tratamiento de datos para determinadas finalidades, en los casos en los que el tratamiento de sus datos esté condicionado al consentimiento.'
            )}
          </li>
          <li>
            {t(
              'Solicitar más detalles e información sobre el uso que VICENS VIVES hace de sus datos de carácter personal.'
            )}
          </li>
          <li>
            {t(
              'Corregir inexactitudes en la información que VICENS VIVES mantiene.'
            )}
          </li>
          <li>
            {t(
              'Borrar información para cuyo uso VICENS VIVES ya no tiene base jurídica.'
            )}
          </li>
          <li>
            {t(
              'Oponerse a cualquier tratamiento de sus datos que tome como base jurídica el interés legítimo, a menos que los motivos para llevar a cabo ese tratamiento compensen cualquier posible perjuicio hacia sus derechos de protección de datos.'
            )}
          </li>
          <li>
            {t(
              'Restringir y limitar la manera en que VICENS VIVES utiliza sus datos de carácter personal.'
            )}
          </li>
          <li>{t('Solicitar la portabilidad de sus datos personales.')}</li>
        </ul>
      </Text>
      <Text>
        {t(
          'Los usuarios podrán realizar cualquier consulta y ejercer cualquiera de sus derechos mediante solicitud dirigida a EDITORIAL VICENS VIVES, S.A. por escrito a la Vía Augusta, 260, 08017 de Barcelona, llamando al 93 252 37 00 o comunicándolo por escrito a nuestra dirección de correo electrónico lopd@vicensvives.es'
        )}
      </Text>
      <Text>
        {t(
          'En caso que los usuarios ejerzan cualquier derecho de los mencionados anteriormente, VICENS VIVES comprobará si el usuario está facultado realmente para ello, atendiendo su petición en los plazos legalmente establecidos por la normativa de protección de datos.'
        )}
      </Text>
      <Text>
        {t(
          'Si el usuario no está satisfecho o está en desacuerdo con la manera en que VICENS VIVES utiliza sus datos de carácter personal y/o con la respuesta que VICENS VIVES haya podido dar ante el ejercicio de cualquiera de sus derechos, puede presentar una reclamación ante la Agencia Española de Protección de Datos u otros órganos competentes.'
        )}
      </Text>
      <Heading level={3}>
        {t('14. Obligaciones de clientes y usuarios')}
      </Heading>
      <Text>
        {t(
          'Con carácter general el usuario se obliga a obrar siempre conforme a la ley, a las buenas costumbres y a las exigencias de la buena fe, empleando la diligencia debida, y absteniéndose de utilizar el website de cualquier forma que pueda impedir, dañar o deteriorar el normal funcionamiento del mismo, los bienes o derechos de VICENS VIVES, sus proveedores, el resto de usuarios o en general de cualquier tercero.'
        )}
      </Text>
      <Text>
        {t(
          'Concretamente, y sin que ello implique restricción alguna a la obligación asumida por el usuario con carácter general de conformidad con el apartado anterior y a las condiciones establecidas en el'
        )}{' '}
        <a href={window.origin} rel='noopener noreferrer'>
          {t('aviso legal y la política de privacidad de VICENS VIVES')}
        </a>
        {t(', el usuario se obliga a:')}
      </Text>
      <Text>
        <ol type='a'>
          <li>
            {t(
              'En caso de registrarse, a facilitar información veraz sobre los datos solicitados en el formulario de registro de usuario o de realización del pedido, y a mantenerlos actualizados.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No introducir, almacenar o difundir en o desde el website, cualquier información o material que fuera difamatorio, injurioso, obsceno, amenazador, xenófobo, incite a la violencia a la discriminación por razón de raza, sexo, ideología, religión o que de cualquier forma atente contra la moral, el orden público, los derechos fundamentales, las libertades públicas, el honor, la intimidad o la imagen de terceros y en general la normativa vigente.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No introducir, almacenar o difundir mediante el PORTAL ningún programa, datos, virus, código, o cualquier otro dispositivo electrónico o físico que sea susceptible de causar daños en el website, en cualquiera de los servicios, o en cualquiera de los equipos, sistemas o redes de el PORTAL de cualquier otro usuario, de los proveedores de el PORTAL en general de cualquier tercero.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'Guardar diligentemente el nombre de usuario y la contraseña propia o que le sea facilitada por el PORTAL, asumiendo la responsabilidad por los daños y perjuicios que pudieran derivarse de un uso indebido de los mismos.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No realizar actividades publicitarias o de explotación comercial a través del website, y a no utilizar los contenidos y la información del mismo para remitir publicidad, o enviar mensajes con cualquier otro fin comercial, ni para recoger o almacenar datos personales de terceros.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No utilizar identidades falsas, ni suplantar la identidad de otros en la utilización del website o en la utilización de cualquiera de los servicios del mismo, incluyendo la utilización en su caso de contraseñas o claves de acceso de terceros o de cualquier otra forma.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No destruir, alterar, utilizar para su uso, inutilizar o dañar los datos, informaciones, programas o documentos electrónicos de el PORTAL, sus proveedores o terceros.'
            )}
          </li>
          <br></br>
          <li>
            {t(
              'No introducir, almacenar o difundir mediante el PORTAL cualquier contenido que infrinja derechos de propiedad intelectual, industrial o secretos empresariales de terceros, ni en general ningún contenido del cual no ostentara, de conformidad con la ley, el derecho a ponerlo a disposición de tercero.'
            )}
          </li>
        </ol>
      </Text>
      <Heading level={3}>
        {t('15. Responsabilidad de VICENS VIVES y licencias de terceros')}
      </Heading>
      <Text>
        {t(
          'Los productos presentados en nuestra web son conformes a la legislación española'
        )}
        .{' '}
      </Text>
      <Text>
        {t(
          'Aunque VICENS VIVES pone el máximo de herramientas necesarias, VICENS VIVES no puede controlar la utilización que los usuarios hacen del portal web, por lo que no garantiza que los usuarios utilicen el portal web de conformidad con la ley, las presentes Condiciones Generales, la moral y buenas costumbres generalmente aceptadas y el orden público, ni tampoco que lo hagan de forma diligente y prudente.'
        )}
      </Text>
      <Text>
        {t(
          'VICENS VIVES declina toda responsabilidad acerca del funcionamiento de los contenidos digitales educativos de terceros, siendo responsables las empresas creadoras de dichos contenidos.'
        )}
      </Text>
      <Heading level={3}>{t('16. Legislación aplicable')}</Heading>
      <Text>
        {t(
          'Con carácter general, las relaciones con los usuarios derivadas de la prestación de servicios contenidos en esta web están sometidos a la legislación y jurisdicción española, concretamente a los Juzgados y Tribunales de la ciudad de Barcelona. Los usuarios de esta web son conscientes de todo lo que se ha expuesto y lo aceptan voluntariamente.'
        )}
      </Text>
      <Text>
        {t(
          'El usuario acepta expresamente los términos y condiciones de uso establecidos anteriormente al marcar la casilla que cita textualmente “he leído y acepto el aviso legal y política de privacidad y los términos y condiciones de compra de VICENS VIVES” que se encuentra en los distintos formularios de compra de productos del portal web de VICENS VIVES.'
        )}
      </Text>
    </div>
  )
}

export default TermsAndCondition
